












































import { Component, Vue } from "vue-property-decorator";
@Component
export default class Success extends Vue {
  public data() {
    return {
      actDetail: {},
    };
  }
  public async created() {
    const loading = (this as any).$loading({
      lock: true,
      text: "加载中",
      spinner: "el-icon-loading",
    });
    try {
      const result = await this.$store.dispatch("actDetail", {
        id: this.$route.params.id,
      });
      this.$data.actDetail = result;
      loading.close();
    } catch (error) {
      loading.close();
      (this as any).$message.error(error.msg || error.message || error);
    }
  }
  /**
   * 复制链接
   */
  public async copyUrl() {
    const loading = (this as any).$loading({
      lock: true,
      text: "请稍等...",
      spinner: "el-icon-loading",
    });
    try {
      const { id } = this.$router.currentRoute.params;
      const result = await this.$store.dispatch("copyUrl", {
        activity_instance_id: id,
      });
      (this as any).$copyText(result.applet_url).then(
        (e: any) => {
          (this as any).$message({
            message: "复制成功",
            type: "success",
          });
        },
        (e: any) => {
          (this as any).$message.error("复制失败" + e);
        }
      );
      loading.close();
    } catch (error) {
      loading.close();
      (this as any).$message.error(error.msg || error.message || error);
    }
  }
  public publish() {
    this.operation("onPublish", Number(this.$route.params.id));
  }
  public async operation(event: string, id: number) {
    this.$data.loading = true;
    try {
      await this.$store.dispatch(event, {
        activity_instance_id: id,
      });
      (this as any).$message.success("发布成功");
    } catch (error) {
      this.$data.loading = false;
      (this as any).$message.error(error.msg || error.message || error);
    }
  }
}
